export default __webpack_public_path__ + "static/media/ft.b7c55511.png";